module.exports = __webpack_public_path__ + "850788e861f50c3e3d605e6692a0dfcf.svg";


//////////////////
// WEBPACK FOOTER
// ./assets/imgs/circle_2.svg
// module id = 173
// module chunks = 0